import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { createGlobalStyle } from 'styled-components';
import { ThemeProvider } from 'styled-components';
import theme from '../theme';
import 'remixicon/fonts/remixicon.css';

const GlobalStyle = createGlobalStyle`
  html {
    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%;
  }
  body {
    background-color: ${(props) =>
      props.background || theme.background.default};
    height: 100vh;
    margin: auto;
    overflow-x: hidden;
    color: ${(props) => props.theme.colors.textPrimary};
    line-height: 1.6;
    letter-spacing: 0.08px;
    font-size: 1.125rem;
    font-family: Noto Sans TC,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif;
    user-select: none;
    -webkit-touch-callout: none;
    -ms-user-select: none;
    border-top: solid 1px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
  }
  #___gatsby {
    height: 100%;
    width: 100%;
  }
  #gatsby-focus-wrapper {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  #gatsby-announcer {
    display: none;
  }
`;
export default function Layout({ children, background, title }) {
  useEffect(() => {
    try {
      // @TODO: compare file version with the latest version on github
      const packageJson = require('../../package.json');
      const currentVersion = packageJson.version;
      console.log(`Current environment: ${process.env.GATSBY_STAGE}`);
      console.log(`Current version: ${currentVersion}`);
    } catch (error) {
      console.error('Error reading version from package.json', error);
    }
  }, []);
  return (
    <React.Fragment>
      <Helmet>
        <title>{title || '1talk liff'}</title>
      </Helmet>
      <GlobalStyle theme={theme} background={background}></GlobalStyle>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </React.Fragment>
  );
}
